import Icon from "components/icon/icon";
import * as React from "react";
import lexemes from "components/lexemes/search";
import { pushEvent } from "lib/gtm";

const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
  pushEvent(event.currentTarget);
};

type HeaderSearchBlockProps = {
  tags?:
    | undefined
    | {
        name: string;
        count: number;
        slug: string;
      }[];
};

export const HeaderSearchBlock: React.FC<HeaderSearchBlockProps> = () => {
  const modalRef = React.useRef<HTMLDivElement>(null);
  const inputSearchRef = React.useRef<HTMLInputElement>(null);
  const onModalTriggerClick = React.useCallback(() => {
    const toggleModal = () => {
      global.document.body.classList.toggle("modal-open");

      if (modalRef.current) {
        modalRef.current.classList.toggle("show");
        modalRef.current.ariaHidden =
          modalRef.current.ariaHidden === "true" ? null : "true";
        modalRef.current.ariaModal =
          modalRef.current.ariaModal === null ? "true" : null;
        modalRef.current.role =
          modalRef.current.role === null ? "dialog" : null;
        modalRef.current.style.display =
          modalRef.current.style.display === "" ? "block" : "";
      }
      if (inputSearchRef.current) {
        inputSearchRef.current.focus();
      }
    };

    toggleModal();
  }, []);
  return (
    <>
      {/* Button trigger modal */}
      <button
        type="button"
        className="btn btn-outline-primary"
        data-seo-name="search-modal-open-cta"
        onClick={onModalTriggerClick}
      >
        <Icon size="md" name={Icon.Name.Search} />
        {lexemes.lxSearchCTAText()}
      </button>
      {/* Modal */}
      <div
        className="modal fade"
        id="search_modal"
        tabIndex={-1}
        aria-labelledby="search_modal_label"
        aria-hidden="true"
        ref={modalRef}
      >
        <div
          className="modal-background"
          data-seo-name="search-modal-close-cta"
        >
          <div
            className="modal-background-inner"
            onClick={onModalTriggerClick}
          ></div>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <form
                role="search"
                method="get"
                id="searchform"
                className="form-inline search-form"
                action="/the-buzz/search"
                onSubmit={onSubmitHandler}
              >
                <div className="modal-header">
                  <p id="search_modal_label" className="screen-reader-text">
                    {lexemes.lxSearchModalAllyTitle()}
                  </p>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={onModalTriggerClick}
                    aria-label="Close"
                    data-seo-name="search-modal-close-cta"
                  ></button>

                  <div className="input-group">
                    <h2>
                      <label className="screen-reader-text" htmlFor="search">
                        {lexemes.lxSearchModalAllyCTALabel()}
                      </label>
                    </h2>
                    <span className="input-group-text">
                      <Icon size="md" name={Icon.Name.Search} />
                    </span>

                    <input
                      type="text"
                      name="search"
                      id="search"
                      className="form-control"
                      placeholder={lexemes.lxSearchModalInputplaceholder()}
                      title={lexemes.lxSearchModalAllyCTALabel()}
                      ref={inputSearchRef}
                    />

                    <button
                      type="submit"
                      id="searchsubmit"
                      className="btn btn-primary search-submit searchtopbtn"
                      value={lexemes.lxSearchCTAText()}
                      data-seo-name="search-action-cta"
                      data-seo-category="search-action-top-cta"
                    >
                      <Icon size="md" name={Icon.Name.Search} />
                      {lexemes.lxSearchCTAText()}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            {/* .modal-content  */}
          </div>
        </div>
        {/* .modal-dialog  */}
      </div>
      {/* .modal  */}
    </>
  );
};

export default HeaderSearchBlock;
